enum ChatGPTMessageRole {
  System = 1,
  Assistant = 2,
  User = 3,
  Function = 4,
}

enum EmbeddingSourceType {
  Article = 'Article',
  DynamicParamOption = 'DynamicParamOption',
}

// These represent directories in the knowledge git repo
// Topic's docs are saved under their respective directory
enum KnowledgeRagTopic {
  CampaignSetupAgent = 'campaign-setup-agent',
  AdBuilderAgent = 'ad-builder-agent',
  CampaignAnalyticsAgent = 'campaign-analytics-agent',
  SupportAgent = 'support-agent',
}

enum GenAIServiceCategory {
  LLM = 0,
  ImageGeneration = 1,
  VideoGeneration = 2,
  ImageAnalysis = 3,
  VideoAnalysis = 4,
}

enum GenAIVendor {
  OpenAI = 0,
  Clipdrop = 2,
  Anthropic = 3,
  Runway = 4,
  Google = 5,
  Bria = 6,
}

export {
  ChatGPTMessageRole,
  EmbeddingSourceType,
  KnowledgeRagTopic,
  GenAIServiceCategory,
  GenAIVendor,
};
